import { render } from "./AlertDialog.vue?vue&type=template&id=1f63414a&scoped=true"
import script from "./AlertDialog.vue?vue&type=script&lang=js"
export * from "./AlertDialog.vue?vue&type=script&lang=js"

import "./AlertDialog.vue?vue&type=style&index=0&id=1f63414a&lang=scss"
import "./AlertDialog.vue?vue&type=style&index=1&id=1f63414a&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f63414a"]])

export default __exports__